const CustomDateStyles = {
	date : {
		fontFamily: 'sans-serif', background: '#f5f5f5', color:'#7660db'
	},
	range : {
		display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
	},
	valid : {
		padding: '2px',
		fontSize: '12px',
		color: '#FC9963',
		textAlign: 'center',
		textTransform: 'capitalize',
		background: 'gray',
		fontWeight: 'bold',
		margin: '10px',
		borderRadius: '2px',
		width: '100%',
		marginBottom: 0
	},
	buttonCustomDateStyles: {
			fontFamily: 'Open Sans, sans-serif',
			background: '#7660db',
			color: '#fff',
			textTransform: 'capitalize',
			display: 'flex',
			textAlign: 'center',
			height: '35px',
	fontSize :'16px',
			justifyContent: 'center',
		marginBottom: '10px',
			'&:hover': {
					background: '#7660db'
			},
			'&:disabled': {
					background: '#7660db',
			}
	},
	selectedOption: {
		margin: '5px',
		backgroundColor: '#7660db',
		color:'#FFFFFF',
		padding: '2px 5px',
	},
	options: { padding: '2px 5px', background: 'none', margin: '5px', border: '1px solid #D8D5FF', cursor: 'pointer', borderRadius: '4px', color: '#7660db', fontFamily: 'sans-serif' }
} as const;

export default CustomDateStyles;
